// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  max-width: 80rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.form-container {
  display: flex;
  justify-content: center;
}

form textarea {
  width: 100%;
  height: 20rem;
  resize: none;
}

form input {
  flex: 1 1;
}

form input,
form button {
  height: 4rem;
  padding: 0.5rem 2rem;
}

form input,
form textarea {
  background-color: var(--theme-dark-page-secondary-background-color);
  border-color: var(--theme-dark-page-secondary-background-color);
  color: var(--theme-dark-page-secondary-foreground-color);
  padding: 1rem 1.5rem;
  border-radius: 12px;
  border-width: 1px;
  border-style: solid;
  transition: all 0.3s ease-out;
}

form input::placeholder,
form textarea::placeholder {
  color: var(--theme-dark-page-secondary-foreground-color);
}

form input:focus::placeholder,
form textarea:focus::placeholder {
  color: var(--theme-dark-page-secondary-foreground-highlight-color);
}

form textarea,
form button,
form input {
  border-width: 1px;
  border-style: solid;
}

form.is-loading textarea,
form.is-loading button,
form.is-loading input {
  opacity: 0.4;
}

textarea:focus,
button:focus,
input:focus {
  outline: none;
}

form textarea:focus,
form input:focus {
  border-color: var(--theme-dark-page-secondary-foreground-highlight-color);
}

form textarea:hover:not(:focus),
form input:hover:not(:focus) {
  background-color: var(--theme-dark-page-secondary-background-highlight-color);
  border-color: var(--theme-dark-page-secondary-background-highlight-color);
}

form button:hover {
  background-color: var(--theme-dark-button-background-highlight-color);
}

form button {
  background-color: var(--theme-dark-button-background-color);
  color: var(--theme-dark-button-foreground-color);
  border: none;
  border-radius: 2rem;
  cursor: pointer;
}

form .form-buttons {
  display: flex;
  width: 100%;
  margin: 1.5rem 0 0;
  gap: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/support-form.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,mEAAmE;EACnE,+DAA+D;EAC/D,wDAAwD;EACxD,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,wDAAwD;AAC1D;;AAEA;;EAEE,kEAAkE;AACpE;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,yEAAyE;AAC3E;;AAEA;;EAEE,6EAA6E;EAC7E,yEAAyE;AAC3E;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,2DAA2D;EAC3D,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["form {\n  max-width: 80rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.form-container {\n  display: flex;\n  justify-content: center;\n}\n\nform textarea {\n  width: 100%;\n  height: 20rem;\n  resize: none;\n}\n\nform input {\n  flex: 1;\n}\n\nform input,\nform button {\n  height: 4rem;\n  padding: 0.5rem 2rem;\n}\n\nform input,\nform textarea {\n  background-color: var(--theme-dark-page-secondary-background-color);\n  border-color: var(--theme-dark-page-secondary-background-color);\n  color: var(--theme-dark-page-secondary-foreground-color);\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  border-width: 1px;\n  border-style: solid;\n  transition: all 0.3s ease-out;\n}\n\nform input::placeholder,\nform textarea::placeholder {\n  color: var(--theme-dark-page-secondary-foreground-color);\n}\n\nform input:focus::placeholder,\nform textarea:focus::placeholder {\n  color: var(--theme-dark-page-secondary-foreground-highlight-color);\n}\n\nform textarea,\nform button,\nform input {\n  border-width: 1px;\n  border-style: solid;\n}\n\nform.is-loading textarea,\nform.is-loading button,\nform.is-loading input {\n  opacity: 0.4;\n}\n\ntextarea:focus,\nbutton:focus,\ninput:focus {\n  outline: none;\n}\n\nform textarea:focus,\nform input:focus {\n  border-color: var(--theme-dark-page-secondary-foreground-highlight-color);\n}\n\nform textarea:hover:not(:focus),\nform input:hover:not(:focus) {\n  background-color: var(--theme-dark-page-secondary-background-highlight-color);\n  border-color: var(--theme-dark-page-secondary-background-highlight-color);\n}\n\nform button:hover {\n  background-color: var(--theme-dark-button-background-highlight-color);\n}\n\nform button {\n  background-color: var(--theme-dark-button-background-color);\n  color: var(--theme-dark-button-foreground-color);\n  border: none;\n  border-radius: 2rem;\n  cursor: pointer;\n}\n\nform .form-buttons {\n  display: flex;\n  width: 100%;\n  margin: 1.5rem 0 0;\n  gap: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
